export default "__VITE_ASSET__CO7wIi3Z__"